module.exports = __webpack_public_path__ + "static/media/mezeh_logo.87e07170.png";